// extracted by mini-css-extract-plugin
var _1 = "HX6eJbIDaXtBUW3d_eIY";
var _2 = "OiGHsFMSUFlThhdXQi9E";
var _3 = "SWwBQJL_uAic3N4nSuZU";
var _4 = "eWu8jLEf4u5F4D9VpFY1";
var _5 = "Gd4lVFnrqwirGv7IAGgS";
var _6 = "QQ9IF_ZIfnSU7Sk8WMMy";
var _7 = "K24aA4SRL7omc7dHymKw";
var _8 = "rLLH3bkM1Tg6YpjqdQ2S";
var _9 = "nm8DuKhfbHDyIYVd0rjW";
var _a = "mP7JUwgDnzb5_Mao4w88";
var _b = "xZFCeRfQijXx4Nhpd_i4";
var _c = "C1FhlO4_Orq7xdGHWGEZ";
var _d = "DxnZ1BNuCVsKptKoO05o";
var _e = "ysD3eU65k_1AAr6rZFqs";
var _f = "TOq4GZXIfMuQvFXPfwTK";
var _10 = "FaKU6SGRF0E9wrn4jh2q";
var _11 = "PdjVezExszVSzyE8rftQ";
var _12 = "XFYv7DT6T2owoRWxMsoV";
var _13 = "i8kjLlb5jow5EEyaURF8";
var _14 = "quhzzOV7PDTBrvn4_jNx";
var _15 = "O20HnvFj4Hg7WoOPCEQg";
export { _1 as "figure", _2 as "image", _3 as "imageCaption", _4 as "is-128x128", _5 as "is-16x16", _6 as "is-24x24", _7 as "is-32x32", _8 as "is-48x48", _9 as "is-64x64", _a as "is-96x96", _b as "theme-cardiology", _c as "theme-dermatology", _d as "theme-empty", _e as "theme-lab", _f as "theme-mentalHealth", _10 as "theme-ophthalmology", _11 as "theme-pulmonology", _12 as "theme-referall", _13 as "theme-sleep", _14 as "theme-white-theme", _15 as "theme-xyz" }
